// extracted by mini-css-extract-plugin
module.exports = {"messageInfo":"OfflineMessageInfo_messageInfo__cyvri"};